window.addEventListener("DOMContentLoaded", () => {
  const freeformForms = document.querySelectorAll("form[data-freeform]");
  freeformForms.forEach((form) => {
    form.addEventListener("freeform-render-field-errors", (event) => {
      event.preventDefault();
      const { errors } = event as Event & {
        errors: Record<string, string[]>;
      };
      Object.entries(errors).forEach(([key, messages]) => {
        if (key) {
          const errorsList = document.createElement("ul");
          errorsList.setAttribute("errors-list", "");
          errorsList.classList.add("tw:list-none", "tw:mb-0");

          for (
            let messageIndex = 0;
            messageIndex < messages.length;
            messageIndex += 1
          ) {
            const message = messages[messageIndex];
            const listItem = document.createElement("li");
            listItem.classList.add("error", "tw:form-error");
            listItem.appendChild(document.createTextNode(message));
            errorsList.appendChild(listItem);
          }

          const inputList = form.querySelectorAll(
            `*[name="${key}"], *[name='${key}[]']`,
          );
          for (
            let inputIndex = 0;
            inputIndex < inputList.length;
            inputIndex += 1
          ) {
            const input = inputList[inputIndex];
            if (
              (input as HTMLInputElement).type === "checkbox" ||
              (input as HTMLInputElement).type === "radio"
            ) {
              input.parentElement?.parentElement?.appendChild(errorsList);
            } else {
              input.parentElement?.appendChild(errorsList);
            }
            input.addEventListener("input", () => {
              if (
                input.textContent !== "" &&
                !(input as HTMLInputElement).validity.valid
              ) {
                input
                  .querySelector("[errors-list]")
                  ?.classList.add("tw:hidden");
              }
            });
          }
        }
      });
    });
    form.addEventListener('freeform-render-success', (event) => {
      event.preventDefault();
      const successBanner = form.querySelector("[data-success-banner]");
      document.querySelector(".freeform-success-banner")?.remove();
      if (successBanner) {
        successBanner.classList.remove("tw:hidden");
      }
    });
    form.addEventListener("freeform-render-form-errors", (event) => {
      event.preventDefault();
      const { errors } = event as Event & {
        errors: Record<string, string[]>;
      };

      const errorBlock = form.querySelector("[data-error-banner]");
      document.querySelector(".freeform-error-banner")?.remove();
      if (errorBlock) {
        errorBlock.classList.remove("tw:hidden");
        if (Object.keys(errors).length > 0) {
          const errorsList = errorBlock.querySelector("ul");
          for (
            let messageIndex = 0;
            messageIndex < Object.keys(errors).length;
            messageIndex += 1
          ) {
            const key = Object.keys(errors)[messageIndex];
            const messages = errors[key];
            const listItem = document.createElement("li");

            listItem.appendChild(document.createTextNode(messages.join(", ")));
            errorsList?.appendChild(listItem);
          }
        }
      }
    });
  });
});
